import { useAuth } from "../auth/useAuth";

/**
 * Returns a `requireAuth(callback)` helper.
 * If the user is already logged in, callback runs immediately.
 * If not, it fires the 'show-guest-auth' event which App.js catches
 * to display the bottom-right sign-in popup; the callback is stored
 * and executed automatically after a successful login.
 */
export function useRequireAuth() {
  const { user } = useAuth();

  const requireAuth = (callback) => {
    if (user) {
      callback();
      return;
    }
    window.dispatchEvent(
      new CustomEvent("show-guest-auth", { detail: { callback } })
    );
  };

  return { requireAuth, isAuthenticated: Boolean(user) };
}
